import { createAsyncThunk } from "@reduxjs/toolkit";
import { useCustomAxios } from "../../shared/lib/customAxios";
import {
  API_ENDPOINTS,
  PRISM_API_BASE_URL,
} from "../../shared/constants/constants";
import { IAddCustomSecurityGroup } from "../../shared/models/settings";
import {
  ICreatePartyRelationships,
  ICreatePartyPreference,
} from "../../shared/models/party";

interface getPartyProductTypeBody {
  partyIds: string[];
}

interface setPartyProductTypeBody {
  partyId: string;
  productTypeId: string;
}
interface updatePartyProductTypeBody {
  partyId: string;
  productTypeId: string;
  statusId: string;
}

export const deletePartyApi = createAsyncThunk(
  "party/deletePartyApi",
  async (reqBody: any) => {
    const { axiosPut } = useCustomAxios();
    try {
      const url = API_ENDPOINTS.deleteParty;
      const response = await axiosPut(url, reqBody);

      return { data: response.data, status: response.status };
    } catch (error: any) {
      return {
        error: error.response.data.message,
        status: error.response.status,
      };
    }
  }
);

export const fetchOrgPartyDetailsApi = createAsyncThunk(
  "party/fetchOrgPartyDetails",
  async (obj: any) => {
    const { axiosGet } = useCustomAxios();
    try {
      let url = `${PRISM_API_BASE_URL}/party/getOrgParties`;
      Object.entries(obj).forEach(
        ([key, value], index) =>
          (url = url + `${index > 0 ? "&" : "?"}${key}=${value}`)
      );
      const response = await axiosGet(url);

      return { data: response.data, status: response.status };
    } catch (error: any) {
      return {
        error: error.response.data.message,
        status: error.response.status,
      };
    }
  }
);
export const fetchPartyByIdApi = createAsyncThunk(
  "party/fetchPartyById",
  async (id: string) => {
    const { axiosGet } = useCustomAxios();
    try {
      const url = `${PRISM_API_BASE_URL}/party/${id}`;
      const response = await axiosGet(url);

      return { data: response.data, status: response.status };
    } catch (error: any) {
      return {
        error: error.response.data.message,
        status: error.response.status,
      };
    }
  }
);
export const fetchPartyDetails = createAsyncThunk(
  "party/fetchPartyDetails",
  async (obj: any) => {
    const { axiosGet } = useCustomAxios();
    try {
      let url = `${PRISM_API_BASE_URL}/party/fetchParties`;
      Object.entries(obj).forEach(
        ([key, value], index) =>
          (url = url + `${index > 0 ? "&" : "?"}${key}=${value}`)
      );
      const response = await axiosGet(url);
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return {
        error: error.response.data.message,
        status: error.response.status,
      };
    }
  }
);
export const createCustomSecurityGroupApi = createAsyncThunk(
  "common/createCustomSecurityGroup",
  async (reqBody: IAddCustomSecurityGroup) => {
    const { axiosPost } = useCustomAxios();
    try {
      const response = await axiosPost(
        API_ENDPOINTS.createCustomSecurityGroup,
        reqBody
      );
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return {
        error: error.response.data.message,
        status: error.response.status,
      };
    }
  }
);
export const updateCustomSecurityGroupApi = createAsyncThunk(
  "common/updateCustomSecurityGroup",
  async (reqBody: IAddCustomSecurityGroup) => {
    const { axiosPost } = useCustomAxios();
    try {
      const response = await axiosPost(
        API_ENDPOINTS.updateCustomSecurityGroup,
        reqBody
      );
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return {
        error: error.response.data.message,
        status: error.response.status,
      };
    }
  }
);
export const createPartyPreferenceApi = createAsyncThunk(
  "party/createPartyPreference",
  async (reqBody: ICreatePartyPreference) => {
    const { axiosPost } = useCustomAxios();
    try {
      const response = await axiosPost(API_ENDPOINTS.createPartyPref, reqBody);
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return {
        error: error.response.data.message,
        status: error.response.status,
      };
    }
  }
);
export const createPartyRelationshipApi = createAsyncThunk(
  "party/createPartyRelationship",
  async (reqBody: ICreatePartyRelationships, { rejectWithValue }) => {
    const { axiosPost } = useCustomAxios();
    try {
      const response = await axiosPost(
        API_ENDPOINTS.createPartyRelationships,
        reqBody
      );
      return { data: response.data, status: response.status };
    } catch (error: any) {
      // return {
      //   error: error.response.data.message,
      //   status: error.response.status,
      // };
      // Updated error handling workflow so that it can be catched in main file
      return rejectWithValue({
        error: error.response.data.message,
        status: error.response.status,
      });
    }
  }
);

export const updatePartyContactMech = createAsyncThunk(
  "updatePartyContactMechs",
  async (reqBody: any) => {
    const { axiosPost } = useCustomAxios();
    let url = `${API_ENDPOINTS.updatePartyContactMech}`;

    try {
      const response = await axiosPost(`${url}`, reqBody);
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return error;
    }
  }
);

export const createPartyContactMech = createAsyncThunk(
  "createPartyContactMechs",
  async (reqBody: any) => {
    const { axiosPost } = useCustomAxios();
    let url = `${API_ENDPOINTS.createPartyContactMech}`;

    try {
      const response = await axiosPost(`${url}`, reqBody);
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return error;
    }
  }
);

export const updateParty = createAsyncThunk(
  "updateParty",
  async (reqBody: any) => {
    const { axiosPut } = useCustomAxios();
    let url = `${API_ENDPOINTS.updateParty}`;

    try {
      const response = await axiosPut(`${url}`, reqBody);
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return error;
    }
  }
);

export const deleteParty = createAsyncThunk(
  "deleteParty",
  async (reqBody: any) => {
    const { axiosPut } = useCustomAxios();
    // let url = `${API_ENDPOINTS.deleteParty}`;
    let url = "http://127.0.0.1:8000/prism-api/v1/party/delete";

    try {
      const response = await axiosPut(`${url}`, reqBody);
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return error;
    }
  }
);

export const createPartyToken = createAsyncThunk(
  "party/createToken",
  async (reqBody: any) => {
    try {
      const { axiosPost } = useCustomAxios();
      let url = `${API_ENDPOINTS.createPartyToken}`;
      const response = await axiosPost(url, reqBody);
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return {
        error: error.response.data.message,
        status: error.response.status,
      };
    }
  }
);

export const registerUsingOTP = createAsyncThunk(
  "register/mobile",
  async (reqObj: any, { rejectWithValue }) => {
    let url = API_ENDPOINTS.registerUsingOTP;
    const { axiosPost } = useCustomAxios();
    try {
      const response = await axiosPost(url, reqObj);
      return { data: response?.data, status: response?.status };
    } catch (error: any) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const registerVerifyGST = createAsyncThunk(
  "register/gst",
  async (reqObj: any, { rejectWithValue }) => {
    let url = API_ENDPOINTS.registerVerifyGST;
    const { axiosPost } = useCustomAxios();
    try {
      const response = await axiosPost(url, reqObj);
      return { data: response?.data, status: response?.status };
    } catch (error: any) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const getPartyProductType = createAsyncThunk(
  "party/getProductType",
  async (reqBody: getPartyProductTypeBody, { rejectWithValue }) => {
    const { axiosPost } = useCustomAxios();
    try {
      const response = await axiosPost(
        API_ENDPOINTS.getPartiesProductType,
        reqBody
      );
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return rejectWithValue({
        error: error.response.data.message,
        status: error.response.status,
      });
    }
  }
);

export const setPartyProductTypeAPI = createAsyncThunk(
  "party/setProductType",
  async (reqBody: setPartyProductTypeBody, { rejectWithValue }) => {
    const { axiosPost } = useCustomAxios();
    try {
      const response = await axiosPost(
        API_ENDPOINTS.createPartyProductType,
        reqBody
      );
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return rejectWithValue({
        error: error.response.data.message,
        status: error.response.status,
      });
    }
  }
);

export const updatePartyProductTypeAPI = createAsyncThunk(
  "party/updateProductType",
  async (reqBody: updatePartyProductTypeBody, { rejectWithValue }) => {
    const { axiosPost } = useCustomAxios();
    try {
      const response = await axiosPost(
        API_ENDPOINTS.updatePartyProductType,
        reqBody
      );
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return rejectWithValue({
        error: error.response.data.message,
        status: error.response.status,
      });
    }
  }
);

export const verifySellerExists = createAsyncThunk(
  "party/verifySellerExists",
  async (reqBody: any, { rejectWithValue }) => {
    const { axiosPost } = useCustomAxios();
    try {
      const response = await axiosPost(
        API_ENDPOINTS.verifySellerDetails,
        reqBody
      );
      return { data: response.data, status: response.status };
    } catch (error: any) {
      // console.log(error);
      return rejectWithValue({
        error: error.message,
        status: error.status,
      });
    }
  }
);

export const searchParties = createAsyncThunk(
  'party/search',
  async (queryParams: any) => {
      const { axiosGet } = useCustomAxios();
      try {
          let url = API_ENDPOINTS.searchParties;
          Object.entries(queryParams).forEach(
              ([key, value], index) =>
                  (url = url + `${index > 0 ? '&' : '?'}${key}=${encodeURIComponent(value as string ?? '')}`)
          );
          const response = await axiosGet(url);

          return { data: response.data, status: response.status };
      } catch (error: any) {
          return {
              error: error.response.data.message,
              status: error.response.status,
          };
      }
  }
)